import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { BOARD_AGE_GROUPS } from "~/features/board/ageGroup";
import { boardMessagesInfiniteQueryOptions } from "~/features/board/api";
import { BoardTemplate } from "~/features/board/BoardTemplate";

// 掲示板フィルターは Default / Sakura 共通の単一選択モデル（callWaiting / age / region）。
// BE は掲示板を絞り込めない（skip ページングのみ）ため、絞り込みはクライアントサイドで行う。
const boardSearchSchema = z.object({
  callWaiting: z.enum(["video", "voice"]).optional(),
  age: z.enum(BOARD_AGE_GROUPS).optional(),
  region: z.coerce.number().int().min(1).max(48).optional(),
});

export const Route = createFileRoute("/_authenticated/board/")({
  validateSearch: boardSearchSchema,
  loaderDeps: ({ search }) => ({
    callWaiting: search.callWaiting,
    age: search.age,
    region: search.region,
  }),
  loader: ({ context: { queryClient }, deps }) =>
    queryClient.ensureInfiniteQueryData(
      boardMessagesInfiniteQueryOptions(deps),
    ),
  component: BoardTemplate,
});
